import jsplumb from 'jsplumb'
import React, { Component } from 'react'

const jsPlumbIn = jsplumb.jsPlumb
const quizOptions = [
  { id: 1, label: 'apple', correctAnswer: 'apple', type: 'question' },
  { id: 2, label: 'banana', correctAnswer: 'banana', type: 'question' },
  { id: 3, label: 'orange', correctAnswer: 'orange', type: 'question' },
  { id: 4, label: 'mango', correctAnswer: 'mango', type: 'question' },
  { id: 5, label: 'apple', type: 'answer' },
  { id: 6, label: 'banana', type: 'answer' },
  { id: 7, label: 'orange', type: 'answer' },
  { id: 8, label: 'mango', type: 'answer' },
]
const R = require('ramda')
var common = {
  isSource: true,
  isTarget: true,
  connector: 'Straight',

  paintStyle: { fill: 'white', outlineStroke: 'blue', strokeWidth: 1 },
  connectorStyle: { outlineStroke: 'blue', strokeWidth: 1 },
  connectorHoverStyle: { strokeWidth: 2 },
}

class MatchTheFollowing extends Component {
  jsPlumbInstance = null
  constructor() {
    super()
    this.state = {
      name: 'React',
      quizOptions: [],
      choice: [],
    }
    this.newArray = []

    //this.newArray2=[]
  }

  componentDidMount() {
    let leftColumnArray = []
    let rightColumnArray = []
    let choiceArray = []
    let choicesArray = []
    let obj = {}
    if (this.props.leftcolumn.length > 0 && this.props.rightcolumn.length > 0) {
      this.props.leftcolumn.map((val, index) => {
        obj = {
          label: val,
          type: 'question',
          correctAnswer: this.props.rightcolumn[index],
        }
        leftColumnArray.push(obj)
      })
      this.props.rightcolumn.map((val, index) => {
        let obj = {
          label: val,
          type: 'answer',
        }
        rightColumnArray.push(obj)
      })
      rightColumnArray = rightColumnArray.sort(() => Math.random() - 0.5)

      console.log('answerArray', rightColumnArray)
      choiceArray = leftColumnArray.concat(rightColumnArray)
      choicesArray = choiceArray.map((val, index) => ({
        ...val,
        id: index + 1,
      }))
    }
    console.log('answerArray', choicesArray)
    if (
      choiceArray.length &&
      this.props.leftcolumn.length > 0 &&
      this.props.rightcolumn.length > 0
    ) {
      console.log('in the did moubt cond')
      let self = this
      self.newArray = JSON.parse(JSON.stringify(choicesArray))
      this.jsPlumbInstance = jsPlumbIn.getInstance({})
      this.props.resetPlumb(this.jsPlumbInstance)
      self.setState({ quizOptions: self.props.choices }, () => {
        self.jsPlumbInstance.ready(function () {
          self.jsPlumbInstance.bind('beforeDrop', function (conn) {
            let sourceStr = conn.sourceId
            let targetStr = conn.targetId
            let sourceID = sourceStr.substring(1, sourceStr.length)
            let targetID = targetStr.substring(1, targetStr.length)
            let source = self.state.quizOptions.find(
              (quiz) => parseInt(quiz.id) === parseInt(sourceID)
            )
            let target = self.state.quizOptions.find(
              (quiz) => parseInt(quiz.id) === parseInt(targetID)
            )
            // Avoid :
            // 1:The source node and the target node are same,
            // 1:The source node and the target node are same type
            if (sourceID === targetID || source.type === target.type) {
              return false
            } else {
              if (source.type === 'question') {
                console.log('arrayCheck', source, target)
                if (source.id) {
                  self.props.onSelect(
                    target.label,
                    self.props.quesId,
                    source.id,
                    target.id
                  )
                }
                const updatedOptions = self.state.quizOptions.map((option) =>
                  parseInt(option.id) === parseInt(target.id)
                    ? {
                        ...option,
                        correct: source.correctAnswer === target.label,
                      }
                    : option
                )
                self.setState({
                  ...this.state,
                  quizOptions: updatedOptions,
                })
              } else if (source.type === 'answer') {
                // console.log('answers',target,source)
                console.log('arrayCheck', target, source)
                self.props.onSelect(
                  source.label,
                  self.props.quesId,
                  target.id,
                  source.id
                )
                const updatedOptions = self.state.quizOptions.map((option) =>
                  parseInt(option.id) === parseInt(source.id)
                    ? {
                        ...option,
                        correct: target.correctAnswer === source.label,
                      }
                    : option
                )
                self.setState({
                  ...this.state,
                  quizOptions: updatedOptions,
                })
              }
              return true
            }
          })
          console.log('radio choices', self.props.choices)
          self.state.quizOptions.forEach((option) => {
            self.jsPlumbInstance.addEndpoint(
              '_' + option.id,
              {
                anchor: option.type == 'answer' ? 'Left' : 'Right',
              },
              common
            )
          })
        })
      })
    }
  }

  showAnswerHandler = (answerId) => {
    console.log('leftcolumn')
    if (
      this.props.leftcolumn.length === 4 &&
      this.props.answerArray[0] &&
      this.props.answerArray[1] &&
      this.props.answerArray[2] &&
      this.props.answerArray[3] &&
      this.props.finalAttempt &&
      this.props.answerArray.length === this.props.leftcolumn.length
    ) {
      return answerId
    } else if (
      this.props.leftcolumn.length === 3 &&
      this.props.answerArray[0] &&
      this.props.answerArray[1] &&
      this.props.answerArray[2] &&
      this.props.finalAttempt &&
      this.props.answerArray.length === this.props.leftcolumn.length
    ) {
      return answerId
    } else if (
      this.props.leftcolumn.length === 2 &&
      this.props.answerArray[0] &&
      this.props.answerArray[1] &&
      this.props.finalAttempt &&
      this.props.answerArray.length === this.props.leftcolumn.length
    ) {
      return answerId
    }
  }

  componentWillUnmount() {
    // console.log('loading unmount')
    const self = this
    self.jsPlumbInstance.empty('list')
    // self.jsPlumbInstance.reset()
  }

  getConnectionsList = () => {
    const self = this
    var connectionList = self.jsPlumbInstance.getConnections()
  }
  render() {
    let height = window.innerHeight
    console.log(window.innerHeight)
    console.log('quizOptions', this.props.answerArray)

    return (
      <div id="diagramContainer">
        <div id="list" className="itemWrap">
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {this.state.quizOptions.map((question, index) =>
              question.type === 'question' ? (
                <div className="d-flex align-items-center">
                  <h4>{index + 1}</h4>
                  <div
                    style={{
                      height:
                        height < 500 ? '40px' : height > 700 ? '80px' : '60px',
                      width:
                        height < 500 ? '40px' : height > 700 ? '80px' : '60px',
                    }}
                    key={question.id}
                    className="item"
                  >
                    <span id={'_' + question.id}>
                      <img
                        style={{ height: '100%', width: '100%' }}
                        src={question.label}
                        className="mr-3 p-1"
                      />
                    </span>
                  </div>
                </div>
              ) : null
            )}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {this.state.quizOptions.map((answer, index) =>
              answer.type === 'answer' ? (
                <div className="d-flex align-items-center">
                  <h4>{this.showAnswerHandler(answer.answerId)}</h4>
                  {/* {this.props.finalAttempt &&
                  this.props.answerArray.length ===
                    this.props.leftcolumn.length ? (
                    <h3 className="mb-0">{index - 3}</h3>
                  ) : (
                    ''
                  )} */}
                  <div
                    key={answer.id}
                    style={{
                      height:
                        height < 500 ? '40px' : height > 700 ? '80px' : '60px',
                      width:
                        height < 500 ? '40px' : height > 700 ? '80px' : '60px',
                    }}
                    className="item"
                  >
                    {/* <span>1</span> */}
                    <span className="ml-3 " id={'_' + answer.id}>
                      <img
                        style={{
                          height: '98%',
                          width: '98%',
                          border:
                            answer.correct === true
                              ? '2px solid #006400	'
                              : answer.correct === false
                              ? '2px solid red'
                              : '',
                        }}
                        src={answer.label}
                        className="ml-3 p-2"
                      />
                      {/* <span>2</span> */}
                    </span>
                  </div>
                </div>
              ) : null
            )}
          </div>
        </div>
      </div>
    )
  }
}
export default MatchTheFollowing
